export const user = {
  name: "User |||| Users",
  tabs: {
    general: "General",
    emailSignature: "Email Signature",
  },
  fields: {
    id: "User ID",
    email: "Email",
    password: "Password",
    name: "Name",
    userGroupsIds: "Groups",
    groupIds: "Groups",
    roleIds: "Roles",
    createdAt: "Created at",
    updatedAt: "Updated at",
    title: "Job Title",
    phone: "Phone",
    emailSignature: "Email Signature",
    isAway: "I am away",
    awayMessage: "Away Message",
  },
  emailSignature: {
    description: "Configure your email signature. These settings will be used when sending emails through the system.",
    titleHelper: "Your job title (e.g., Support Engineer, Sales Manager)",
    phoneHelper: "Phone number for your email signature",
    signatureHelper: "HTML email signature. Supports placeholders: {{name}}, {{title}}, {{email}}, {{phone}}",
    awayStatus: "Away Status",
    awayMessageHelper: "Auto-reply message when you are away",
  },
};
